export default __webpack_public_path__ + "static/media/789.34c33116.png";